import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import loc, { format } from 'owa-localize';
import { smimeComposeHasCloudAttachments } from 'owa-locstrings/lib/strings/smimecomposehascloudattachments.locstring.json';

export default function showErrorForCloudOrUriAttachments(
    attachmentFileNames: string[],
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void
) {
    attachmentFileNames &&
        attachmentFileNames.length &&
        infoBarAddHandler('ErrorSmimeHasCloudOrUriAttachments', [
            format(loc(smimeComposeHasCloudAttachments), attachmentFileNames.join(', ')),
        ]);
}
